module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAMBAMAAADxOqKKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUxpcf///////////////////////////////////////////////////+bWS5kAAAANdFJOUwAPIO/D1QrMF7R4li9EvEMUAAAAQklEQVQI12NgYMg0YEABjL5oAu13UQU4YtEEVO/eNRREAgy+d1HAdUwBoJY7SDrEgLbevYRqbSa6AMNedAEuI2QeAOKyKtptg4c2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prev_page.png
// module id = GRaS
// module chunks = 0